<p-dialog
  *ngIf="questionList"
  [appendTo]="'body'"
  [(visible)]="detailsControl.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="!isSaving"
  (visibleChange)="hideDialog()"
>
  <div class="flex justify-content-between align-items-center mt-2">
    <div class="flex gap-2 align-items-center">
      <button class="secondary-button p-0 mr-2" [disabled]="isSaving" (click)="hideDialog()" data-clarity-unmask="true">
        X
      </button>
      <button class="semiround-button" [disabled]="isSaving || isAnyEditing" (click)="moveUp()" data-clarity-unmask="true">
        <i class="pi pi-angle-up"></i>
      </button>
      <button class="semiround-button" [disabled]="isSaving || isAnyEditing" (click)="moveDown()" data-clarity-unmask="true">
        <i class="pi pi-angle-down"></i>
      </button>
      <div *ngIf="questionList">
        {{ questionIndex + 1 }} z {{ questionList.length }} wyników
      </div>
    </div>
    <!-- <div class="text-sm text-400">Data utworzenie: 2023-09-12</div> -->
  </div>

  <ng-template pTemplate="content">
    <div class="question-title-row flex align-items-center justify-content-between">
      <div class="flex justify-content-left align-contnt-center mt-5 mb-3 gap-3">
        <div class="font-semibold text-xl">NR {{ question.questionNumber }}</div>
        <div class="text-rounded" *ngIf="question.knowledgeTypeId">
          {{
            question.knowledgeType === null
              ? "Ważność nie przypisana"
              : question.knowledgeType
          }}
        </div>
        <div
          *ngIf="question.lastUpdated"
          class="flex justify-content-center align-items-center text-sm text-400"
        >
          {{ formatDate(question.lastUpdated) }}
        </div>
      </div>
          <div *ngIf="question.isDeleted" class="deleted-info">Usunięte</div>
          <div *ngIf="question.needsReview" class="review-info" data-clarity-unmask="true">
            <i class="pi pi-flag mr-1"></i>Do sprawdzenia<span *ngIf="question.reviewNote">: {{ question.reviewNote }}</span>
          </div>
          <div *ngIf="!question.needsReview && question.reviewedAt" class="text-sm text-400">
            Sprawdzone {{ formatDate(question.reviewedAt) }}<span *ngIf="question.reviewedByEmail"> ({{ question.reviewedByEmail }})</span>
          </div>
          <div *ngIf="question.uaMachineTranslated" class="machine-translation-info" data-clarity-unmask="true"
            pTooltip="Katalog ministerstwa nie ma wersji ukraińskiej tego pytania; tekst UA to nasze tłumaczenie (DeepL lub redakcja). Kursant widzi przy pytaniu ikonkę „Tłumaczenie nieoficjalne”. Odznacz w edycji tylko po wklejeniu wersji ministerstwa." tooltipPosition="left">
            <i class="pi pi-language mr-1"></i>Tłumaczenie UA własne<span *ngIf="question.uaMachineTranslatedAt"> ({{ formatDate(question.uaMachineTranslatedAt) }})</span>
          </div>
          <div *ngIf="!question.uaMachineTranslated && !question.isDeleted && lacksUa(question)" class="missing-translation-info" data-clarity-unmask="true"
            pTooltip="Ministerstwo nie dostarcza tłumaczenia tego pytania na ukraiński. Przetłumacz je w zakładce „Bez tłumaczenia ministerstwa” albo wpisz tłumaczenie w edycji." tooltipPosition="left">
            <i class="pi pi-exclamation-circle mr-1"></i>Brak tłumaczenia UA
          </div>
    </div>

    <div class="my-3">
      <div *ngIf="!editingMedia">
        <div class="flex justify-content-between align-items-center gap-3">
          <div class="flex-1">
            <div *ngIf="mediaLoading" class="flex justify-content-center align-items-center" style="min-height: 8rem">
              <i class="pi pi-spin pi-spinner text-4xl text-400"></i>
            </div>
            <video
              *ngIf="question.videoLink && question.videoLink !== null"
              class="w-full"
              [class.hidden]="mediaLoading"
              [src]="
                environment.webApiUrl +
                '/Media?resourceName=' +
                question.videoLink +
                '&expectedFormat=webm'
              "
              controls
              (loadeddata)="mediaLoading = false"
            ></video>
            <img
              *ngIf="question.imageLink && question.imageLink !== null"
              class="w-full"
              [class.hidden]="mediaLoading"
              alt="Nie znaleziono pliku lub nie został jeszcze przeknowertowany"
              [src]="environment.webApiUrl + '/Image?imageName=' + question.imageLink"
              (load)="mediaLoading = false"
              (error)="mediaLoading = false"
            />
            <div
              class="font-semibold text-base"
              *ngIf="
                !mediaLoading && (
                  (!question.videoLink && !question.imageLink) ||
                  (question.videoLink === null && question.imageLink === null)
                )
              "
            >
              Pytanie bez mediów
            </div>
          </div>

          <div class="flex gap-2">
            <button
              type="button"
              class="transparent-button"
              [disabled]="isAnyEditing || isSaving"
              (click)="enableMediaEditing()"
              pTooltip="Edytuj media"
              data-clarity-unmask="true"
            >
              <i class="pi pi-pencil"></i>
            </button>
            
            <button
              *ngIf="question.videoLink || question.imageLink"
              type="button"
              class="transparent-button text-red-500"
              [disabled]="savingMedia || isAnyEditing || isSaving"
              (click)="removeMedia()"
              pTooltip="Usuń media"
              data-clarity-unmask="true"
            >
              <i class="pi pi-spin pi-spinner" *ngIf="savingMedia"></i>
              <i class="pi pi-trash" *ngIf="!savingMedia"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="editingMedia">
        <div class="mb-3">
          <fas-services-upload
            [environment]="environment.webApiUrl"
            [allowedExtensions]="[
                '.png',
                '.jpg',
                '.jpeg',
                '.webp',
                '.mp4',
                '.avi',
                '.mov',
                '.wmv'
              ]"
            [mainIcon]="'pi-image'"
            mainMessage="Wybierz plik graficzny lub wideo z dysku lub przeciągnij tu."
            [multiple]="false"
            (fileSelected)="onMediaFileSelected($event)"
          >
          </fas-services-upload>
        </div>

        <div class="flex gap-2">
          <button
            type="button"
            class="transparent-button"
            pTooltip="Zapisz media"
            [disabled]="savingMedia || !selectedMediaFile"
            (click)="saveMedia()"
            data-clarity-unmask="true"
          >
            <i class="pi pi-check" *ngIf="!savingMedia"></i>
            <i class="pi pi-spin pi-spinner" *ngIf="savingMedia"></i>
          </button>

          <button
            type="button"
            class="transparent-button"
            pTooltip="Anuluj edycję mediów"
            [disabled]="savingMedia"
            (click)="cancelMediaEditing()"
            data-clarity-unmask="true"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </div>

    <form [formGroup]="questionUpdateForm" autocomplete="off">
      @if(detailsControl.isEditing){
      <div
        class="flex w-full flex-column gap-2 justify-content-start align-items-start"
      >
        <div
          class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator top-decorator off-bottom-border"
        >
          <div class="title">Pytanie PL</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input
              type="text"
              class="default-input w-full"
              formControlName="question"
            />
          </div>
        </div>
        <div
          class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border"
        >
          <div class="title">Pytanie ENG</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input
              type="text"
              class="default-input w-full"
              formControlName="questionENG"
            />
          </div>
        </div>
        <div
          class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border"
        >
          <div class="title">Pytanie DE</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input
              type="text"
              class="default-input w-full"
              formControlName="questionDE"
            />
          </div>
        </div>
        <div
          class="flex w-full justify-content-left align-items-center gap-3 form-decorator"
        >
          <div class="title">Pytanie UA</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input
              type="text"
              class="default-input w-full"
              formControlName="questionUA"
            />
          </div>
        </div>
        <div class="flex w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Tłumaczenie UA</div>
          <div class="w-full flex align-items-center gap-2 text-sm">
            <p-checkbox formControlName="uaMachineTranslated" [binary]="true" inputId="uaMachineTranslated" data-clarity-unmask="true"></p-checkbox>
            <label for="uaMachineTranslated" class="cursor-pointer">Tłumaczenie własne (DeepL lub redakcja), nie z katalogu ministerstwa – kursant widzi ikonkę „Tłumaczenie nieoficjalne”. Odznacz tylko po wklejeniu wersji ministerstwa.</label>
          </div>
        </div>
      </div>
      }@else {
      <div>
        <div class="mb-2 font-semibold text-base">Pytanie:</div>
        <div class="mb-4 text-base">{{ question.question }}</div>
      </div>
      }


      @if(detailsControl.isEditing){
      <div class="flex w-full flex-column gap-2 justify-content-start align-items-start">
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź A (PL)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerA" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź B (PL)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerB" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Odpowiedź C (PL)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerC" />
          </div>
        </div>

        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź A (ENG)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerENGA" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź B (ENG)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerENGB" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Odpowiedź C (ENG)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerENGC" />
          </div>
        </div>

        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź A (DE)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerDEA" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź B (DE)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerDEB" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Odpowiedź C (DE)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerDEC" />
          </div>
        </div>

        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź A (UA)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerUAA" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator off-bottom-border">
          <div class="title">Odpowiedź B (UA)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerUAB" />
          </div>
        </div>
        <div *ngIf="isSpecialistQuestion" class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Odpowiedź C (UA)</div>
          <div class="w-full cursor-pointer" (click)="editOn()">
            <input type="text" class="default-input w-full" formControlName="answerUAC" />
          </div>
        </div>

       
        <div class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
          <div class="title">Prawidłowa odpowiedź</div>
          <div class="w-full">
            <p-dropdown
              formControlName="correctAnswer"
              [options]="getCorrectAnswerOptions()"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz odpowiedź"
              appendTo="body"
              styleClass="w-full"
              class="w-full"
            ></p-dropdown>
          </div>
        </div>
      </div>
      }@else {
              <div>
        <div class="mb-2 font-semibold text-base">Odpowiedzi:</div>
        <ng-container *ngFor="let answer of answerOptions">
          <div
            class="mb-1 p-2 border-round-md"
            *ngIf="question.knowledgeTypeId === 1"
            [ngClass]="{
              'correct-answer': answer.value === question.correctAnswer
            }"
          >
            {{ answer.value }}
          </div>
          <div
            class="mb-1 py-2 px-3 border-round-md"
           *ngIf="question.knowledgeTypeId === 2"
            [ngClass]="{
              'correct-answer': answer.value === question.correctAnswer
            }"
          >
            {{ answer.value }}&#10099; {{ answer.label }}
          </div>
        </ng-container>
      </div>
      }

      <div
        class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator"
      >
        <div class="title">Rodzaj pytania</div>
        <div class="w-full cursor-pointer" (click)="editOn()">
          <select
            formControlName="questionCategoryGuid"
            [ngClass]="{ 'input-off': !detailsControl.isEditing }"
            class="default-input w-full"
            name="type"
          >
            <option
              *ngFor="let category of questionCategories"
              [value]="category.guid"
            >
              {{ category.questionCategoryName }}
            </option>
          </select>
        </div>
      </div>
      
      <div class="flex py-2 w-full justify-content-left align-items-center gap-3 form-decorator">
        <div class="title flex justify-content-left align-items-center">
          Kategoria
        </div>
        @if(detailsControl.isEditing){
          <div class="w-full cursor-pointer" (click)="editOn()">
            <p-multiSelect
              formControlName="category"
              [options]="availableExams"
              optionLabel="examName"
              placeholder="A, B, C, C1"
              appendTo="body"
              panelStyleClass="max-w-30rem"
              styleClass="custom-multiselect w-full"
              class="w-full"
              display="chip"
              [maxSelectedLabels]="10"
            >
            </p-multiSelect>
          </div>
        }@else {
          <input
            class="default-input w-full max-w-8rem input-off"
            [value]="question.examCategories"
            readonly
          />
        }
      </div>

      <div
        class="flex py-2 w-full justify-content-start align-items-center gap-3 form-decorator"
      >
        <div class="flex w-full align-items-center justify-content-start">
          <div class="title-row ml-0">Liczba punktów</div>
          <div class="cursor-pointer" (click)="editOn()">
            <select
              formControlName="points"
              [ngClass]="{ 'input-off': !detailsControl.isEditing }"
              class="default-input w-full max-w-4rem"
              name="type"
            >
              <option
                *ngFor="let points of pointsOptions"
                [value]="points.value"
              >
                {{ points.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex w-full align-items-center justify-content-start">
          <div class="title-row ml-0">Ważność pytania</div>
          <div class="cursor-pointer" (click)="editOn()">
            <select
              formControlName="knowledgeTypeId"
              [ngClass]="{ 'input-off': !detailsControl.isEditing }"
              class="default-input w-full max-w-8rem"
              name="type"
              (change)="onKnowledgeTypeChange($event)"
            >
              <option
                *ngFor="let knowledge of knowledgeTypeOptions"
                [value]="knowledge.value"
              >
                {{ knowledge.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div
        class="flex justify-content-left align-items-center gap-3 form-decorator"
      >
        <div class="title">Wyjaśnienie PL</div>

        <div *ngIf="!editingExplain['pl']" class="w-full">
          <div
            *ngIf="question.explainPL"
            (click)="startExplainEdit('pl')"
            class="cursor-pointer p-2 border-round hover:bg-gray-100"
          >
            {{ question.explainPL }}
          </div>
          <button
            *ngIf="!hasAnyExplanation()"
            class="primary-button mt-2"
            (click)="startExplainEdit('pl')"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
            Dodaj wyjaśnienie PL
          </button>
          <button
            *ngIf="hasAnyExplanation() && !question.explainPL"
            class="secondary-button mt-2"
            (click)="startExplainEdit('pl')"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
            Dodaj PL
          </button>
        </div>

        <div *ngIf="editingExplain['pl']" class="w-full">
          <form [formGroup]="explainFormPL">
            <textarea
              formControlName="explainContent"
              rows="10"
              placeholder="Wprowadź wyjaśnienie po polsku..."
              class="default-input w-full mt-2"
            ></textarea>
            <div class="mt-2">
              <p-checkbox
                formControlName="autoTranslate"
                label="Przetłumacz automatycznie na inne języki (ENG, DE, UA)"
                [binary]="true"
              />
            </div>
            <div class="flex gap-2 mt-2">
              <button
                type="button"
                class="primary-button"
                (click)="saveExplain('pl')"
                [disabled]="
                  !explainFormPL.get('explainContent')?.value?.trim() ||
                  savingExplain['pl']
                "
                data-clarity-unmask="true"
              >
                <i *ngIf="!savingExplain['pl']" class="pi pi-save"></i>
                <i
                  *ngIf="savingExplain['pl']"
                  class="pi pi-spin pi-spinner"
                ></i>
                Zapisz
              </button>
              <button
                type="button"
                class="secondary-button"
                (click)="cancelExplainEdit('pl')"
                [disabled]="savingExplain['pl']"
                data-clarity-unmask="true"
              >
                Anuluj
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        *ngIf="canAddOtherLanguages()"
        class="flex justify-content-left align-items-center gap-3 form-decorator"
      >
        <div class="title">Wyjaśnienie ENG</div>

        <div *ngIf="!editingExplain['eng']" class="w-full">
          <div
            *ngIf="question.explainENG"
            (click)="startExplainEdit('eng')"
            class="cursor-pointer p-2 border-round hover:bg-gray-100"
          >
            {{ question.explainENG }}
          </div>
          <div *ngIf="!question.explainENG" class="text-400 italic">
            Brak wyjaśnienia
          </div>
          <button
            *ngIf="!question.explainENG"
            class="secondary-button mt-2"
            (click)="startExplainEdit('eng')"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
            Dodaj ENG
          </button>
        </div>

        <!-- Edit mode -->
        <div *ngIf="editingExplain['eng']" class="w-full">
          <form [formGroup]="explainFormENG">
            <textarea
              formControlName="explainContent"
              rows="10"
              placeholder="Enter explanation in English..."
              class="default-input w-full mt-2"
            ></textarea>
            <div class="flex gap-2 mt-2">
              <button
                type="button"
                class="primary-button"
                (click)="saveExplain('eng')"
                [disabled]="
                  !explainFormENG.get('explainContent')?.value?.trim() ||
                  savingExplain['eng']
                "
                data-clarity-unmask="true"
              >
                <i *ngIf="!savingExplain['eng']" class="pi pi-save"></i>
                <i
                  *ngIf="savingExplain['eng']"
                  class="pi pi-spin pi-spinner"
                ></i>
                Zapisz
              </button>
              <button
                type="button"
                class="secondary-button"
                (click)="cancelExplainEdit('eng')"
                [disabled]="savingExplain['eng']"
                data-clarity-unmask="true"
              >
                Anuluj
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        *ngIf="canAddOtherLanguages()"
        class="flex justify-content-left align-items-center gap-3 form-decorator"
      >
        <div class="title">Wyjaśnienie DE</div>

        <div *ngIf="!editingExplain['de']" class="w-full">
          <div
            *ngIf="question.explainDE"
            (click)="startExplainEdit('de')"
            class="cursor-pointer p-2 border-round hover:bg-gray-100"
          >
            {{ question.explainDE }}
          </div>
          <div *ngIf="!question.explainDE" class="text-400 italic">
            Brak wyjaśnienia
          </div>
          <button
            *ngIf="!question.explainDE"
            class="secondary-button mt-2"
            (click)="startExplainEdit('de')"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
            Dodaj DE
          </button>
        </div>

        <!-- Edit mode -->
        <div *ngIf="editingExplain['de']" class="w-full">
          <form [formGroup]="explainFormDE">
            <textarea
              formControlName="explainContent"
              rows="10"
              placeholder="Erklärung auf Deutsch eingeben..."
              class="default-input w-full mt-2"
            ></textarea>
            <div class="flex gap-2 mt-2">
              <button
                type="button"
                class="primary-button"
                (click)="saveExplain('de')"
                [disabled]="
                  !explainFormDE.get('explainContent')?.value?.trim() ||
                  savingExplain['de']
                "
                data-clarity-unmask="true"
              >
                <i *ngIf="!savingExplain['de']" class="pi pi-save"></i>
                <i
                  *ngIf="savingExplain['de']"
                  class="pi pi-spin pi-spinner"
                ></i>
                Zapisz
              </button>
              <button
                type="button"
                class="secondary-button"
                (click)="cancelExplainEdit('de')"
                [disabled]="savingExplain['de']"
                data-clarity-unmask="true"
              >
                Anuluj
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        *ngIf="canAddOtherLanguages()"
        class="flex justify-content-left align-items-center gap-3 form-decorator"
      >
        <div class="title">Wyjaśnienie UA</div>

        <div *ngIf="!editingExplain['ua']" class="w-full">
          <div
            *ngIf="question.explainUA"
            (click)="startExplainEdit('ua')"
            class="cursor-pointer p-2 border-round hover:bg-gray-100"
          >
            {{ question.explainUA }}
          </div>
          <div *ngIf="!question.explainUA" class="text-400 italic">
            Brak wyjaśnienia
          </div>
          <button
            *ngIf="!question.explainUA"
            class="secondary-button mt-2"
            (click)="startExplainEdit('ua')"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
            Dodaj UA
          </button>
        </div>

        <!-- Edit mode -->
        <div *ngIf="editingExplain['ua']" class="w-full">
          <form [formGroup]="explainFormUA">
            <textarea
              formControlName="explainContent"
              rows="10"
              placeholder="Введіть пояснення українською..."
              class="default-input w-full mt-2"
            ></textarea>
            <div class="flex gap-2 mt-2">
              <button
                type="button"
                class="primary-button"
                (click)="saveExplain('ua')"
                [disabled]="
                  !explainFormUA.get('explainContent')?.value?.trim() ||
                  savingExplain['ua']
                "
                data-clarity-unmask="true"
              >
                <i *ngIf="!savingExplain['ua']" class="pi pi-save"></i>
                <i
                  *ngIf="savingExplain['ua']"
                  class="pi pi-spin pi-spinner"
                ></i>
                Zapisz
              </button>
              <button
                type="button"
                class="secondary-button"
                (click)="cancelExplainEdit('ua')"
                [disabled]="savingExplain['ua']"
                data-clarity-unmask="true"
              >
                Anuluj
              </button>
            </div>
          </form>
        </div>
      </div>
    </form>

    <!-- <p-tabPanel header="Pliki multimedialne">
        <div class="flex justify-content-center align-contnt-center gap-2">
          <p-fileUpload
            chooseLabel="Wybierz"
            cancelLabel="Usuń"
            [disabled]="true"
            [customUpload]="true"
            (onSelect)="onSelectFile($event)"
            [showUploadButton]="false"
            styleClass="mt-4"
            accept="video/*"
            [previewWidth]="50"
          >
            <ng-template pTemplate="content" let-files>
              <div
                class="flex flex-column justify-content-center align-contnt-center gap-2"
              >
                <i class="pi pi-video text-center"></i>
                <div class="text-center">
                  Wybierz plik video z dysku lub przeciągnij tu.
                </div>
              </div>
            </ng-template>
          </p-fileUpload>
          <p-fileUpload
            chooseLabel="Wybierz"
            cancelLabel="Usuń"
            [disabled]="true"
            [customUpload]="true"
            (onSelect)="onSelectFile($event)"
            styleClass="mt-4"
            [showUploadButton]="false"
            accept="audio/*"
          >
            <ng-template pTemplate="content" let-files>
              <div
                class="flex flex-column justify-content-center align-contnt-center gap-2"
              >
                <i class="pi pi-megaphone text-center"></i>
                <div class="text-center">
                  Wybierz plik audio z dysku lub przeciągnij tu.
                </div>
              </div>
            </ng-template>
          </p-fileUpload>
        </div>
      </p-tabPanel> -->
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="details-footer flex align-items-center justify-content-between mb-2">
      <div *ngIf="detailsControl.isEditing" class="flex gap-2">
        <p-button
          [loading]="loadingSaveQuestion"
          [disabled]="!questionUpdateForm.valid || loadingSaveQuestion"
          label="Zapisz zmiany"
          icon="pi pi-save"
          (onClick)="saveQuestion()"
          data-clarity-unmask="true"
        >
        </p-button>
        <button [disabled]="loadingSaveQuestion" class="secondary-button" (click)="editToggle()" data-clarity-unmask="true">Anuluj</button>
      </div>

      <div *ngIf="!detailsControl.isEditing">
        <button class="primary-button" [disabled]="isAnyEditing" (click)="editToggle()" data-clarity-unmask="true">
          <i class="pi pi-pencil"></i>
          Edytuj
        </button>
      </div>

      @if(question.needsReview){
        <button (click)="toggleReview()" [disabled]="reviewSaving || isSaving || isAnyEditing" class="secondary-button" data-clarity-unmask="true">
          <i class="pi pi-check"></i>Sprawdzone
        </button>
      }
      @else {
        <button (click)="toggleReview()" [disabled]="reviewSaving || isSaving || isAnyEditing" class="secondary-button" data-clarity-unmask="true">
          <i class="pi pi-flag"></i>Do sprawdzenia
        </button>
      }

      @if(question.isDeleted){
        <button (click)="deleteQuestion()" [disabled]="isSaving || isAnyEditing" class="secondary-button" data-clarity-unmask="true">
          <i class="pi pi-refresh"></i>Przywróć pytanie
        </button>
      }
      @else {
          <button (click)="deleteQuestion()" [disabled]="isSaving || isAnyEditing" class="secondary-button" data-clarity-unmask="true">
          <i class="pi pi-trash"></i>Usuń pytanie
        </button>
      }
    </div>
  </ng-template>
</p-dialog>
